import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ToggleSmallUI from "../../../../UI/ToggleSmallUI";
import { Languages, LanguagesIcon, PanelLeft, PanelTop, Theater, Thermometer } from "lucide-react";
import EditorCourseCardBasics from "./EditorPlayerCardBasics";


const EditorCourseCard =({playerCard1Object ,setLeadObjectFields,activeSettingBack,setActiveSettingBack})=>{
        const dispatch = useDispatch();  
        // const [itemNameTitle,setItemNameTitle] =useState(playerCard1Object?.fullname?.title)
         const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
                {
                  
                  dispatch({type: "CURSOR",payload:true  });
              
                  dispatch({type: "CURSORTEXT",payload:CursorText})
                  dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
                  dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
                }
                 
                const handleMouseLeave = () => {
                  
                  dispatch({type: "CURSOR",payload:false})
              
                  dispatch({type: "CURSORTEXT",payload:""})
              
                  dispatch({type: "CURSORTEXTBG",payload:""})
                  dispatch({type: "CURSORTEXTCOLOR",payload:""})
                
              
              }
  const [activeSetting, setActiveSetting] = useState(activeSettingBack?"CTA":"contents");
  const [activeSettingContents, setActiveSettingContents] = useState("titleText");
  
  const [activeSettingContentsTitleCard, setActiveSettingContentsTitleCard] = useState("titleLabels");
  
  const [activeSettingContents2, setActiveSettingContents2] = useState("sidebarCard");
  const [activeSettingContents4, setActiveSettingContents4] = useState("Titles");
  
   const [fontFamilyTitlePopup ,setFontFamilyTitlePopup]  = useState(false);
   const [fontFamilyMetaPopup ,setFontFamilyMetaPopup]  = useState(false);
   const [fontFamilyTagsPopup ,setFontFamilyTagsPopup]  = useState(false);
   const [fontFamilyButtonsPopup ,setFontFamilyButtonsPopup]  = useState(false);
  
   const [fontFamilySubTitlePopup ,setFontFamilySubTitlePopup]  = useState(false);
  
   const fonts=[
  {name:"AlumniSansSC-Regular",
  fontFamily:"AlumniSansSCRegular , 'Helvetica Neue',sans-serif"
 }
 ,{name:"AlumniSansSC-Italic",
  fontFamily:"AlumniSansSCItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Regular",
  fontFamily:"InterRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Italic",
  fontFamily:"InterItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Lato-Light",
  fontFamily:"LatoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Montserrat-Light",
  fontFamily:"MontserratLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Poppins-Regular",
  fontFamily:"PoppinsRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Light",
  fontFamily:"RalewayLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Thin",
  fontFamily:"RalewayThin , 'Helvetica Neue',sans-serif"
 }
   ]

   useEffect(()=>{
    setActiveSetting(activeSettingBack?"CTA":"contents")
   },[activeSettingBack])
    return (<>
      <div style={{paddingTop:"18px",fontSize:"24px",fontWeight:"900"}}> Player Card Settings</div>
     <div style={{background:"#ffffff",display:"flex",justifyContent:"space-around",borderRadius:"15px",paddingTop:"5px",position:"relative",top:"30px"}}>  
                
                  
                   <div style={{background:activeSetting=="contents"?"rgba(144, 202, 249,1)":"#ffffff",width:"90px",color:activeSetting=="contents"?"#ffffff":"#222222",borderRadius:"15px",fontSize:"13px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSetting("contents");setActiveSettingBack("contents")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Titles & Settings</div>  
                        <div style={{background:activeSetting=="CTA"?"rgba(144, 202, 249,1)":"#ffffff",width:"100px",color:activeSetting=="CTA"?"#ffffff":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSetting("CTA");setActiveSettingBack("CTA")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Video Settings</div>       
                   
                   <div style={{background:activeSetting=="Design"?"rgba(144, 202, 249,1)":"#ffffff",width:"70px",color:activeSetting=="Design"?"#ffffff":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSetting("Design");setActiveSettingBack("Design")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Designs</div> 
                   
               </div>{activeSetting=="contents"?<>
                <div style={{padding:"15px",marginTop:"5px",}}><h2> Player Card Editor (Texts & Styles)</h2></div>
                <div className="scroll-lf-settings" style={{marginTop:"-15px"}} >
  
                      <div style={{position:"relative",display:"flex",justifyContent:"space-between",padding:"10px",borderRadius:"10px",
                      background:"rgba(144, 202, 249,0.31)"}}>
              <div className="lf-title-head-style">Compact Course Card </div>
  <ToggleSmallUI state={playerCard1Object?.compact?.status} toggleState={(state)=>{ setLeadObjectFields('compact',"status",state)}} />
  </div>  
               {activeSettingContents=="titleText"?
               <div>
                
                <div style={{background:"#ffffff",display:"flex",justifyContent:"space-around",borderRadius:"15px",marginBottom:"10px",paddingTop:"0px"}}>  
                {/* {blockType=="design"? */}
                 
                  {/* :""} */}
                    <div style={{border:activeSettingContentsTitleCard=="titleLabels"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"130px",color:activeSettingContentsTitleCard=="titleLabels"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSettingContentsTitleCard("titleLabels")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Sidebar Styles</div>  
                   <div style={{border:activeSettingContentsTitleCard=="cardStyles"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"100px",color:activeSettingContentsTitleCard=="cardStyles"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSettingContentsTitleCard("cardStyles")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Main Card Styles </div>  
                           
                   
                  
                   
               </div>
               
                {activeSettingContentsTitleCard=="cardStyles"?<>

               
                  </>:<>
                  
              <div style={{background:"#ffffff",display:"flex",justifyContent:"space-around",borderRadius:"15px",marginBottom:"10px",paddingTop:"0px"}}>  
                {/* {blockType=="design"? */}
                 
                  {/* :""} */}
                  
                   <div style={{border:activeSettingContents4=="Titles"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"70px",color:activeSettingContents4=="Titles"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSettingContents4("Titles")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Titles  </div>   <div style={{border:activeSettingContents4=="Settings"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"70px",color:activeSettingContents4=="Tags"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSettingContents4("Settings");setActiveSettingContents2("sidebarCard")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Card   </div>  
                           
                         <div style={{border:activeSettingContents4=="Button"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"70px",color:activeSettingContents4=="Button"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSettingContents4("Button");setActiveSettingContents2("topBar")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Button  </div> 
                     <div style={{border:activeSettingContents4=="FontFamily"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"130px",color:activeSettingContents4=="FontFamily"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSettingContents4("FontFamily")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Font Family</div>       
                   
                  
                   
               </div>
                   
               {activeSettingContents4=="Titles"?<><div className="lf-title-box-outer">
               <div className="lf-title-head-style">Sidebar Text  Settings</div></div>
               <div className="lf-title-head-style">Curriculum</div>
<div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Curriculum`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.topBar.title1} onChange={(e)=>{setLeadObjectFields('topBar',"title1",e.target.value)}} />
</div> <div className="lf-title-head-style">Sub-courses</div>
<div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Sub-courses`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.topBar.title2} onChange={(e)=>{setLeadObjectFields('topBar',"title2",e.target.value)}} />
</div>

                <div className="lf-title-head-style">Milestone</div>
                  <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Milestone `} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.milestone?.title} onChange={(e)=>{setLeadObjectFields('milestone',"title",e.target.value)}} />
</div>
               <div className="lf-title-head-style">Section</div>
               
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Section`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.section?.title} onChange={(e)=>{setLeadObjectFields('section',"title",e.target.value)}} />
</div> 

<div className="lf-title-head-style">Chapter</div>
               
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Chapter`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.chapter?.title} onChange={(e)=>{setLeadObjectFields('chapter',"title",e.target.value)}} />
</div> 

<div className="lf-title-head-style">Lesson</div>
               
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Lesson`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.lessonCard?.title1} onChange={(e)=>{setLeadObjectFields('lessonCard',"title1",e.target.value)}} />
</div> 
<div className="lf-title-head-style">I have completed this lesson</div>
               
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`I have completed this lesson`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.lessonCard?.title2} onChange={(e)=>{setLeadObjectFields('lessonCard',"title2",e.target.value)}} />
</div> 


<div className="lf-title-head-style">comments</div>
               
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`comments`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.lessonCardButtons?.title1} onChange={(e)=>{setLeadObjectFields('lessonCardButtons',"title1",e.target.value)}} />
</div> 


<div className="lf-title-head-style">report</div>
               
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`report`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.lessonCardButtons?.title2} onChange={(e)=>{setLeadObjectFields('lessonCardButtons',"title2",e.target.value)}} />
</div> 

<div className="lf-title-head-style">notes</div>
               
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`notes`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.lessonCardButtons?.title3} onChange={(e)=>{setLeadObjectFields('lessonCardButtons',"title3",e.target.value)}} />
</div> 

<div className="lf-title-head-style">pdf</div>
               
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`pdf`} type="text"
  rows={1} name="courseTitle" value={playerCard1Object?.lessonCardButtons?.title4} onChange={(e)=>{setLeadObjectFields('lessonCardButtons',"title4",e.target.value)}} />
</div> 



</>:""}

{activeSettingContents4=="Settings"?<>
<div style={{background:"#ffffff",display:"flex",justifyContent:"space-around",borderRadius:"15px",marginBottom:"10px",paddingTop:"0px"}}>  
                {/* {blockType=="design"? */}
                 
                  {/* :""} */}
                  
                   <div style={{border:activeSettingContents2=="sidebarCard"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"100px",color:activeSettingContents2=="sidebarCard"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSettingContents2("sidebarCard")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Sidebar </div>  
                           
                    <div style={{border:activeSettingContents2=="milestone"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"130px",color:activeSettingContents2=="milestone"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSettingContents2("milestone")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Milestone</div>  
                   <div style={{border:activeSettingContents2=="section"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"130px",color:activeSettingContents2=="section"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSettingContents2("section")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Section</div> 
                   <div style={{border:activeSettingContents2=="chapter"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"130px",color:activeSettingContents2=="chapter"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSettingContents2("chapter")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Chapter</div>       
                   
                   <div style={{border:activeSettingContents2=="lessonCard"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"130px",color:activeSettingContents2=="lessonCard"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSettingContents2("lessonCard")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Lesson</div>       
                   
                  
                   
               </div>
{activeSettingContents2=="sidebarCard"?<>
<EditorCourseCardBasics    objectValue={playerCard1Object?.sidebarCard} 
objectName={"sidebarCard"}
displayName={"Sidebar "}
 
  callbackItemValue={(value,name,obName,obval)=>{ 
    if(name=="textColor"||name=="bgColor"||name=="layoutBG"||name=="iconColor"||name=="iconBgColor"||name=="progressBarColor"||name=="progressBarInnerColor"||name=="toggleColor"||name=="toggleThumbColor"||name=="toggeleCardBgColor"){
     setLeadObjectFields(obName,name, {...obval?.[name],color: value });
     }
      if(name=="borderType"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderType: value });
     }if(name=="borderWidth"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderWidth:{...obval?.border?.borderWidth,value: value} });
     }if(name=="borderColor"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderColor:{...obval?.border?.borderColor,color: value }});
     }
    if(name=="borderRadius"){
     
     setLeadObjectFields(obName,"borderRadius",value);
     } if(name=="aspectRatio"){
    
     setLeadObjectFields(obName,"imageThumbnail",{...obval?.imageThumbnail,aspectRatio:{...obval?.imageThumbnail?.aspectRatio,value: value }});
     }
     

  }}  />

</>:""}

{activeSettingContents2=="milestone"?<>
<EditorCourseCardBasics    objectValue={playerCard1Object?.milestone} 
objectName={"milestone"}
displayName={"Milestone "}
 
  callbackItemValue={(value,name,obName,obval)=>{ 
    if(name=="textColor"||name=="bgColor"||name=="layoutBG"||name=="iconColor"||name=="iconBgColor"||name=="progressBarColor"||name=="progressBarInnerColor"||name=="toggleColor"||name=="toggleThumbColor"||name=="toggeleCardBgColor"){
     setLeadObjectFields(obName,name, {...obval?.[name],color: value });
     }
      if(name=="borderType"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderType: value });
     }if(name=="borderWidth"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderWidth:{...obval?.border?.borderWidth,value: value} });
     }if(name=="borderColor"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderColor:{...obval?.border?.borderColor,color: value }});
     }
    if(name=="borderRadius"){
     
     setLeadObjectFields(obName,"borderRadius",value);
     } if(name=="aspectRatio"){
    
     setLeadObjectFields(obName,"imageThumbnail",{...obval?.imageThumbnail,aspectRatio:{...obval?.imageThumbnail?.aspectRatio,value: value }});
     }
     

  }}  />

</>:""}

{activeSettingContents2=="section"?<>
<EditorCourseCardBasics    objectValue={playerCard1Object?.section} 
objectName={"section"}
displayName={"Section "}
 
  callbackItemValue={(value,name,obName,obval)=>{ 
    if(name=="textColor"||name=="bgColor"||name=="layoutBG"||name=="iconColor"||name=="iconBgColor"||name=="progressBarColor"||name=="progressBarInnerColor"||name=="toggleColor"||name=="toggleThumbColor"||name=="toggeleCardBgColor"){
     setLeadObjectFields(obName,name, {...obval?.[name],color: value });
     }
      if(name=="borderType"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderType: value });
     }if(name=="borderWidth"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderWidth:{...obval?.border?.borderWidth,value: value} });
     }if(name=="borderColor"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderColor:{...obval?.border?.borderColor,color: value }});
     }
    if(name=="borderRadius"){
     
     setLeadObjectFields(obName,"borderRadius",value);
     } if(name=="aspectRatio"){
    
     setLeadObjectFields(obName,"imageThumbnail",{...obval?.imageThumbnail,aspectRatio:{...obval?.imageThumbnail?.aspectRatio,value: value }});
     }
     

  }}  />

</>:""}
{activeSettingContents2=="chapter"?<>
<EditorCourseCardBasics    objectValue={playerCard1Object?.chapter} 
objectName={"chapter"}
displayName={"Chapter "}
 
  callbackItemValue={(value,name,obName,obval)=>{ 
    if(name=="textColor"||name=="bgColor"||name=="layoutBG"||name=="iconColor"||name=="iconBgColor"||name=="progressBarColor"||name=="progressBarInnerColor"||name=="toggleColor"||name=="toggleThumbColor"||name=="toggeleCardBgColor"){
     setLeadObjectFields(obName,name, {...obval?.[name],color: value });
     }
      if(name=="borderType"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderType: value });
     }if(name=="borderWidth"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderWidth:{...obval?.border?.borderWidth,value: value} });
     }if(name=="borderColor"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderColor:{...obval?.border?.borderColor,color: value }});
     }
    if(name=="borderRadius"){
     
     setLeadObjectFields(obName,"borderRadius",value);
     } if(name=="aspectRatio"){
    
     setLeadObjectFields(obName,"imageThumbnail",{...obval?.imageThumbnail,aspectRatio:{...obval?.imageThumbnail?.aspectRatio,value: value }});
     }
     

  }}  />

</>:""}
{activeSettingContents2=="lessonCard"?<>


          <div style={{display:"flex",justifyContent:"space-between"}}>
            <h3> Lesson Theme </h3>
                                       <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                              
                                             <div style={{display:"flex",justifyContent:"center"}}>
                                             <PanelTop onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                   <div style={{position:"relative",fontSize:"14px"}}>T1</div>
                                                                    </div>  
                              <input type="radio" title="Set As Years"   checked={playerCard1Object?.lessonCard?.lessonCardTheme=="T1"?"yes":""}
                   className="input-textbox"  value={"T1"}  name="itemVisibility1"  
                   onClick={e=>{setLeadObjectFields('lessonCard',"lessonCardTheme","T1")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{paddingTop:"15px"}}>
                                             <div style={{display:"flex",flexDirection: "column",width:"70px"}} >
                                              
                                             <div style={{display:"flex",justifyContent:"center"}}>
                                             <PanelLeft onMouseEnter={handleMouseEnter}
                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ 
                                                                      
                                                                     }} style={{position:"relative"}}   color="#555" size={25}/>
                                                                     </div>
                                                                   <div style={{position:"relative",fontSize:"14px"}}>T2</div>
                                                                    </div>  
                              <input type="radio" title="Set As Years"   checked={playerCard1Object?.lessonCard?.lessonCardTheme=="T2"?"yes":""}
                   className="input-textbox"  value={"T2"}  name="itemVisibility1"  
                   onClick={e=>{setLeadObjectFields('lessonCard',"lessonCardTheme","T2")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        
                        </div> 



<EditorCourseCardBasics    objectValue={playerCard1Object?.lessonCard} 
objectName={"lessonCard"}
displayName={"Lesson "}
 
  callbackItemValue={(value,name,obName,obval)=>{ 
    if(name=="textColor"||name=="bgColor"||name=="layoutBG"||name=="iconColor"||name=="iconBgColor"||name=="progressBarColor"||name=="progressBarInnerColor"||name=="toggleColor"||name=="toggleThumbColor"||name=="toggeleCardBgColor"){
     setLeadObjectFields(obName,name, {...obval?.[name],color: value });
     }
      if(name=="borderType"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderType: value });
     }if(name=="borderWidth"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderWidth:{...obval?.border?.borderWidth,value: value} });
     }if(name=="borderColor"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderColor:{...obval?.border?.borderColor,color: value }});
     }
    if(name=="borderRadius"){
     
     setLeadObjectFields(obName,"borderRadius",value);
     } if(name=="aspectRatio"){
    
     setLeadObjectFields(obName,"imageThumbnail",{...obval?.imageThumbnail,aspectRatio:{...obval?.imageThumbnail?.aspectRatio,value: value }});
     }
     

  }}  />

</>:""}


</>:""}

{activeSettingContents4=="Button"?<>
<div style={{background:"#ffffff",display:"flex",justifyContent:"space-around",borderRadius:"15px",marginBottom:"10px",paddingTop:"0px"}}>  
                {/* {blockType=="design"? */}
                 
                  {/* :""} */}
                  
                   <div style={{border:activeSettingContents2=="topBar"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"100px",color:activeSettingContents2=="topBar"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSettingContents2("topBar")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        >Top Bar Buttons </div>  
                           
                    <div style={{border:activeSettingContents2=="lessonCardButtons"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"130px",color:activeSettingContents2=="lessonCardButtons"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSettingContents2("lessonCardButtons")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Lesson Buttons</div>  
                       
                   
                  
                   
               </div>
{activeSettingContents2=="topBar"?<>
<EditorCourseCardBasics    objectValue={playerCard1Object?.topBar} 
objectName={"topBar"}
displayName={"Top Bar "}
 
  callbackItemValue={(value,name,obName,obval)=>{ 
    if(name=="textColor"||name=="bgColor"||name=="layoutBG"||name=="iconColor"||name=="iconBgColor"||name=="progressBarColor"||name=="progressBarInnerColor"||name=="toggleColor"||name=="toggleThumbColor"||name=="toggeleCardBgColor"){
     setLeadObjectFields(obName,name, {...obval?.[name],color: value });
     }
      if(name=="borderType"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderType: value });
     }if(name=="borderWidth"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderWidth:{...obval?.border?.borderWidth,value: value} });
     }if(name=="borderColor"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderColor:{...obval?.border?.borderColor,color: value }});
     }
    if(name=="borderRadius"){
     
     setLeadObjectFields(obName,"borderRadius",value);
     } if(name=="aspectRatio"){
    
     setLeadObjectFields(obName,"imageThumbnail",{...obval?.imageThumbnail,aspectRatio:{...obval?.imageThumbnail?.aspectRatio,value: value }});
     }
     

  }}  />

</>:""}

{activeSettingContents2=="lessonCardButtons"?<>
<EditorCourseCardBasics    objectValue={playerCard1Object?.lessonCardButtons} 
objectName={"lessonCardButtons"}
displayName={"Lesson Card Buttons "}
 
  callbackItemValue={(value,name,obName,obval)=>{ 
    if(name=="textColor"||name=="bgColor"||name=="layoutBG"||name=="iconColor"||name=="iconBgColor"||name=="progressBarColor"||name=="progressBarInnerColor"||name=="toggleColor"||name=="toggleThumbColor"||name=="toggeleCardBgColor"){
     setLeadObjectFields(obName,name, {...obval?.[name],color: value });
     }
      if(name=="borderType"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderType: value });
     }if(name=="borderWidth"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderWidth:{...obval?.border?.borderWidth,value: value} });
     }if(name=="borderColor"){
     setLeadObjectFields(obName,"border", {...obval?.border,borderColor:{...obval?.border?.borderColor,color: value }});
     }
    if(name=="borderRadius"){
     
     setLeadObjectFields(obName,"borderRadius",value);
     } if(name=="aspectRatio"){
    
     setLeadObjectFields(obName,"imageThumbnail",{...obval?.imageThumbnail,aspectRatio:{...obval?.imageThumbnail?.aspectRatio,value: value }});
     }
     

  }}  />

</>:""}



</>:""}
 {activeSettingContents4=="FontFamily"?<>
    <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between",}}>
                                    <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",width:"320px"}}>
                                        <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.headerFont?.family?.fontFamily}}>
                                            Header Font Family:    "{playerCard1Object?.titleFonts?.headerFont?.family?.name}"</div>  </div><div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"space-between"}} >
                                                                
                                                                 <Languages onMouseEnter={handleMouseEnter}
                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                         
                                                                 </div> 
                                                  <input type="checkbox" title=""   checked={fontFamilySubTitlePopup?"yes":""}
                                       className="input-textbox"  value={"k"}  name="fintFamily1"  
                                       onChange={e=>{setFontFamilySubTitlePopup(e.target.checked);}}/>
                                            <span class={"boxCardBorder-two"}></span> </label>
                    {fontFamilySubTitlePopup?
                      <div  style={{position:"absolute",borderRadius:"15px",right:"-5px",bottom:"70px",zIndex:"9999999",background:"#ffffff",}}>
                     <div style={{fontSize:"18px",borderRadius:"5px",background:" rgba(144, 202, 249,0.31)",fontWeight:"bold",padding:"10px",marginTop:"5px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",}}>
                                      <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.headerFont?.family?.fontFamily}}>
                                        Font :   "{playerCard1Object?.titleFonts?.headerFont?.family?.name}"</div>  </div>
                                     <div  className="colorPickerDynamic" style={{borderRadius:"15px",height:"250px",overflowY:"auto",margin:"0px",background:"rgba(144, 202, 249,0.1)",padding:"5px",width:"220px",}}>
                                      
                                        {fonts?.map((item,index) => (
                                       <>  <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"left",alignItems:"left"}} >
                                                                 <div style={{width:"40px"}}><LanguagesIcon color={"#333"} size={24}/></div>  
                                                                         <div style={{fontSize:"16px",fontFamily:item?.fontFamily}}> {item?.name} </div>              
                                                                 </div> 
                                                  <input type="radio" title=""   checked={playerCard1Object?.titleFonts?.headerFont?.family?.name==item?.name?"yes":""}
                                       className="input-textbox"  value={item?.name}  name="FontFamily2"  
                                       onClick={e=>{
                                          setLeadObjectFields(
  "titleFonts",
  "headerFont",
  {
    ...playerCard1Object?.titleFonts?.headerFont,
   family: item,
  }
)
                                   }}/>
                                            <span class={"boxCardBorder-two"}></span> </label> </>
                                        ))}
                                        </div></div>:""}</div></div> 
                                        
    <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between",}}>
                                    <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",width:"320px"}}>
                                        <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.titleFont?.family?.fontFamily}}>
                                           Title Font Family:    "{playerCard1Object?.titleFonts?.titleFont?.family?.name}"</div>  </div><div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"space-between"}} >
                                                                
                                                                 <Languages onMouseEnter={handleMouseEnter}
                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                         
                                                                 </div> 
                                                  <input type="checkbox" title=""   checked={fontFamilyTitlePopup?"yes":""}
                                       className="input-textbox"  value={"k"}  name="fintFamily1"  
                                       onChange={e=>{setFontFamilyTitlePopup(e.target.checked);}}/>
                                            <span class={"boxCardBorder-two"}></span> </label>
                    {fontFamilyTitlePopup?
                      <div  style={{position:"absolute",borderRadius:"15px",right:"-5px",bottom:"70px",zIndex:"9999999",background:"#ffffff",}}>
                     <div style={{fontSize:"18px",borderRadius:"5px",background:" rgba(144, 202, 249,0.31)",fontWeight:"bold",padding:"10px",marginTop:"5px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",}}>
                                      <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.titleFont?.family?.fontFamily}}>
                                        Font :   "{playerCard1Object?.titleFonts?.titleFont?.family?.name}"</div>  </div>
                                     <div  className="colorPickerDynamic" style={{borderRadius:"15px",height:"250px",overflowY:"auto",margin:"0px",background:"rgba(144, 202, 249,0.1)",padding:"5px",width:"220px",}}>
                                      
                                        {fonts?.map((item,index) => (
                                       <>  <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"left",alignItems:"left"}} >
                                                                 <div style={{width:"40px"}}><LanguagesIcon color={"#333"} size={24}/></div>  
                                                                         <div style={{fontSize:"16px",fontFamily:item?.fontFamily}}> {item?.name} </div>              
                                                                 </div> 
                                                  <input type="radio" title=""   checked={playerCard1Object?.titleFonts?.titleFont?.family?.name==item?.name?"yes":""}
                                       className="input-textbox"  value={item?.name}  name="FontFamily"  
                                       onClick={e=>{setLeadObjectFields(
  "titleFonts",
  "titleFont",
  {
    ...playerCard1Object?.titleFonts?.titleFont,
   family: item,
  }
)}}/>
                                            <span class={"boxCardBorder-two"}></span> </label> </>
                                        ))}
                                        </div></div>:""}</div></div>  

   
 <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between",}}>
                                    <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",width:"320px"}}>
                                        <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.subtitleFont?.family?.fontFamily}}>
                                           Subtitles Labels  Font Family:    "{playerCard1Object?.titleFonts?.subtitleFont?.family?.name}"</div>  </div><div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"space-between"}} >
                                                                
                                                                 <Languages onMouseEnter={handleMouseEnter}
                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                         
                                                                 </div> 
                                                  <input type="checkbox" title=""   checked={fontFamilyMetaPopup?"yes":""}
                                       className="input-textbox"  value={"k"}  name="fintFamily1"  
                                       onChange={e=>{setFontFamilyMetaPopup(e.target.checked);}}/>
                                            <span class={"boxCardBorder-two"}></span> </label>
                    {fontFamilyMetaPopup?
                      <div  style={{position:"absolute",borderRadius:"15px",right:"-5px",bottom:"70px",zIndex:"9999999",background:"#ffffff",}}>
                     <div style={{fontSize:"18px",borderRadius:"5px",background:" rgba(144, 202, 249,0.31)",fontWeight:"bold",padding:"10px",marginTop:"5px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",}}>
                                      <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.subtitleFont?.family?.fontFamily}}>
                                        Font :   "{playerCard1Object?.titleFonts?.subtitleFont?.family?.name}"</div>  </div>
                                     <div  className="colorPickerDynamic" style={{borderRadius:"15px",height:"250px",overflowY:"auto",margin:"0px",background:"rgba(144, 202, 249,0.1)",padding:"5px",width:"220px",}}>
                                      
                                        {fonts?.map((item,index) => (
                                       <>  <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"left",alignItems:"left"}} >
                                                                 <div style={{width:"40px"}}><LanguagesIcon color={"#333"} size={24}/></div>  
                                                                         <div style={{fontSize:"16px",fontFamily:item?.fontFamily}}> {item?.name} </div>              
                                                                 </div> 
                                                  <input type="radio" title=""   checked={playerCard1Object?.titleFonts?.subtitleFont?.family?.name==item?.name?"yes":""}
                                       className="input-textbox"  value={item?.name}  name="FontFamily1"  
                                       onClick={e=>{setLeadObjectFields(
  "titleFonts",
  "subtitleFont",
  {
    ...playerCard1Object?.titleFonts?.subtitleFont,
   family: item,
  }
)}}/>
                                            <span class={"boxCardBorder-two"}></span> </label> </>
                                        ))}
                                        </div></div>:""}</div></div>    





   
 <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between",}}>
                                    <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",width:"320px"}}>
                                        <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.tagsFont?.family?.fontFamily}}>
                                           Tags Labels  Font Family:    "{playerCard1Object?.titleFonts?.tagsFont?.family?.name}"</div>  </div><div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"space-between"}} >
                                                                
                                                                 <Languages onMouseEnter={handleMouseEnter}
                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                         
                                                                 </div> 
                                                  <input type="checkbox" title=""   checked={fontFamilyTagsPopup?"yes":""}
                                       className="input-textbox"  value={"k"}  name="fintFamily1"  
                                       onChange={e=>{setFontFamilyTagsPopup(e.target.checked);}}/>
                                            <span class={"boxCardBorder-two"}></span> </label>
                    {fontFamilyTagsPopup?
                      <div  style={{position:"absolute",borderRadius:"15px",right:"-5px",bottom:"70px",zIndex:"9999999",background:"#ffffff",}}>
                     <div style={{fontSize:"18px",borderRadius:"5px",background:" rgba(144, 202, 249,0.31)",fontWeight:"bold",padding:"10px",marginTop:"5px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",}}>
                                      <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.tagsFont?.family?.fontFamily}}>
                                        Font :   "{playerCard1Object?.titleFonts?.tagsFont?.family?.name}"</div>  </div>
                                     <div  className="colorPickerDynamic" style={{borderRadius:"15px",height:"250px",overflowY:"auto",margin:"0px",background:"rgba(144, 202, 249,0.1)",padding:"5px",width:"220px",}}>
                                      
                                        {fonts?.map((item,index) => (
                                       <>  <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"left",alignItems:"left"}} >
                                                                 <div style={{width:"40px"}}><LanguagesIcon color={"#333"} size={24}/></div>  
                                                                         <div style={{fontSize:"16px",fontFamily:item?.fontFamily}}> {item?.name} </div>              
                                                                 </div> 
                                                  <input type="radio" title=""   checked={playerCard1Object?.titleFonts?.tagsFont?.family?.name==item?.name?"yes":""}
                                       className="input-textbox"  value={item?.name}  name="FontFamily1"  
                                       onClick={e=>{setLeadObjectFields(
  "titleFonts",
  "tagsFont",
  {
    ...playerCard1Object?.titleFonts?.tagsFont,
   family: item,
  }
)}}/>
                                            <span class={"boxCardBorder-two"}></span> </label> </>
                                        ))}
                                        </div></div>:""}</div></div>   



   
 <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between",}}>
                                    <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",width:"320px"}}>
                                        <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.buttonFont?.family?.fontFamily}}>
                                           Button Text  Font Family:    "{playerCard1Object?.titleFonts?.buttonFont?.family?.name}"</div>  </div><div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"space-between"}} >
                                                                
                                                                 <Languages onMouseEnter={handleMouseEnter}
                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                         
                                                                 </div> 
                                                  <input type="checkbox" title=""   checked={fontFamilyButtonsPopup?"yes":""}
                                       className="input-textbox"  value={"k"}  name="fintFamily1"  
                                       onChange={e=>{setFontFamilyButtonsPopup(e.target.checked);}}/>
                                            <span class={"boxCardBorder-two"}></span> </label>
                    {fontFamilyButtonsPopup?
                      <div  style={{position:"absolute",borderRadius:"15px",right:"-5px",bottom:"70px",zIndex:"9999999",background:"#ffffff",}}>
                     <div style={{fontSize:"18px",borderRadius:"5px",background:" rgba(144, 202, 249,0.31)",fontWeight:"bold",padding:"10px",marginTop:"5px",
                                     paddingLeft:"10px",display:"flex",justifyContent:"left",}}>
                                      <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:playerCard1Object?.titleFonts?.buttonFont?.family?.fontFamily}}>
                                        Font :   "{playerCard1Object?.titleFonts?.buttonFont?.family?.name}"</div>  </div>
                                     <div  className="colorPickerDynamic" style={{borderRadius:"15px",height:"250px",overflowY:"auto",margin:"0px",background:"rgba(144, 202, 249,0.1)",padding:"5px",width:"220px",}}>
                                      
                                        {fonts?.map((item,index) => (
                                       <>  <label onMouseEnter={
                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                <div style={{display:"flex",justifyContent:"left",alignItems:"left"}} >
                                                                 <div style={{width:"40px"}}><LanguagesIcon color={"#333"} size={24}/></div>  
                                                                         <div style={{fontSize:"16px",fontFamily:item?.fontFamily}}> {item?.name} </div>              
                                                                 </div> 
                                                  <input type="radio" title=""   checked={playerCard1Object?.titleFonts?.buttonFont?.family?.name==item?.name?"yes":""}
                                       className="input-textbox"  value={item?.name}  name="FontFamily1"  
                                       onClick={e=>{setLeadObjectFields(
  "titleFonts",
  "buttonFont",
  {
    ...playerCard1Object?.titleFonts?.buttonFont,
   family: item,
  }
)}}/>
                                            <span class={"boxCardBorder-two"}></span> </label> </>
                                        ))}
                                        </div></div>:""}</div></div>   




</>:""}

     </>}
    </div>:""}
    {activeSettingContents=="imageVideos"?<div>
     
           
               
    
                 







    </div>:""}
  </div> </>:""}
    <style>{ `
      .scroll-lf-settings{ overflow-x:hidden;padding:3px;
     overflow-y:auto;height:55vh}
        
     .LeadInfoCardTextBox, .LeadInfoCardTextBox:hover{
    background: #f9f9f9;
    box-shadow:var(--shadow-default);
   color:#222 ;
   margin:10px;outline: #fff;
   border: 2px solid rgba(144, 202, 249,1) !important;
   border-radius: 10px;;
    }
    .LeadInfoCardTextBox:focus{ box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.08); border-color: #6366f1; }

    .lf-title-box-outer{background:#fff;padding:5px;border-radius:15px;margin:5px;margin-top:10px}
.lf-title-head-style{display:flex;justify-content:left;font-size:18px;padding:5px;padding-left:20px;align-items:left;}
        
/* md */
@media (min-width: 992px) and (max-width: 1199px) {
}
/* sm */
@media (min-width: 768px) and (max-width: 991px) {
}
/* xs */
@media (max-width: 767px) {
.scroll-lf-settings{
     overflow-y:auto;height:95vh !important}
}
        `}
        </style>
    </>)
}

export default EditorCourseCard;